import React from "react";
import { useNavigate } from "react-router-dom";
import { AppShell } from "../components/Nav";

export default function SoftTransition() {
  const navigate = useNavigate();

  return (
    <AppShell>
      <div className="min-h-[80vh] flex items-center justify-center px-6">
        <div className="max-w-lg text-center">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] mb-4">
            Next · Head-to-Head
          </div>
          <h1 className="font-display text-4xl md:text-5xl leading-tight mb-6">
            Refining Your Matches
          </h1>
          <p className="text-white/65 text-lg mb-4">
            We'll show you pairs from your selections. Just choose the one that feels more aligned.
          </p>
          <p className="text-white/40 text-sm mb-10">
            This helps us understand your preferences better.
          </p>
          <button
            onClick={() => {
  const picks = JSON.parse(localStorage.getItem("selected_profiles") || "[]");

  if (!picks || picks.length < 7) {
    alert("You need 7 eligible matches before comparing.");
    return;
  }

  fetch('/api/matches/validate', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem("bm_auth_token")}`
  },
  body: JSON.stringify({ picks })
})
.then(r => r.json())
.then(d => {
  if (!d.ok) {
    alert(d.reason || "Selection invalid");
    return;
  }
  navigate("/head-to-head");
});;
}}
            data-testid="soft-transition-cta"
            className="rounded-full bg-gradient-gold text-[#080B14] font-semibold px-8 py-4 glow-gold hover:scale-[1.02] transition-transform"
          >
            Start Comparing
          </button>
        </div>
      </div>
    </AppShell>
  );
}
